<template>
  <div class="row">
    <div class="col-12">
      <b-card header="Current Assignments" header-tag="h4" body-class="mb-3 record_card_body">
        <div class="row">
          <div class="col-12">
            <h4 class="mb-0 b2_color">Currently assigned workers: {{distinct_assignments}}</h4>
            <p class="b3_color">The above figure is how many workers you currently have assigned to <span v-if="crmType === 'payroll'">Genius</span><span v-else-if="crmType ===
            'recruitment'">V3</span> Orders (Regardless of how many different orders they are simultaneously assigned to).</p>
            <h5 class="mb-0 b3_color">Default sorting for the below table is: First Name, Surname, Start Date.</h5>
            <p class="b3_color">You will find that if a worker is assigned to multiple locations (sites) then they will appear in the table multiple times, once for each location
              .</p>
          </div>
          <div class="col-12" style="min-height: 600px">
            <currentDatable :row-data="current_assignments" :loading-message="'Loading Current Assignments...'" :no-rows-message="'No Current Assignments Found'"
                            :columns="current_ass_columns" :type="'assignment'" :record-type="'assignment'" :paginationPageSize="50"></currentDatable>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import currentDatable from 'datatables/assignments_datatable'

export default {
  name: "c_assigned_workers",
  components: {
    currentDatable
  },
  data() {
    return {
      heightStyle: 'height: calc(100vh - 180px);',
      current_assignments: null,
      distinct_assignments: null,

      current_ass_columns: [
        {headerName: 'Worker Name', maxWidth: 280, valueGetter: this.worker_name_vg},
          // {headerName: 'Assigned Date', minWidth: 150, valueGetter: this.h_assigned_date_vg},
        {headerName: 'Order Ref', maxWidth: 150, field: 'order_ref'},
        {headerName: 'Location', maxWidth: 300, field: 'job_address_full'},
        // {headerName: 'Short Site Name', minWidth: 200, field: 'order_job.rel_order_location.short_site_name'},

        // {headerName: 'Job Title', minWidth: 150, field: 'order_job.rel_order_position.job_title'},
        // {headerName: 'Pay Rate', minWidth: 100, valueGetter: this.h_pay_rate_vg},
        {headerName: 'Start Date', maxWidth: 120, valueGetter: this.h_start_date_vg},
        {headerName: 'End Date', maxWidth: 120, valueGetter: this.h_end_date_vg},
        {headerName: 'Pay Type', maxWidth: 120, field: 'pay_type'},
        {headerName: 'Pay Rate', maxWidth: 120, valueGetter: this.h_pay_rate_vg},
        // {headerName: 'Gang Leader', maxWidth: 130, valueGetter: this.h_gang_leader_vg},
        // {headerName: 'Part of Gang', maxWidth: 130, valueGetter: this.h_part_of_gang_vg},
        // {headerName: 'Gang Lead By', minWidth: 135, valueGetter: this.h_gang_lead_by_vg},
      ],
    }
  },
  beforeMount() {
    axios.get(this.crmApiPath + 'contact/' + this.$store.state.auth.me.contact_id + '/company/show').then(company => {
      axios.get(this.crmApiPath + 'assignments/company/current_assignments/' + company.data.id).then(curr_ass => {
        this.current_assignments = curr_ass.data.current_assignments;
        this.distinct_assignments = curr_ass.data.distinct_workers;
      })
    });
  },
  methods: {
    // Value Getters
    worker_name_vg(params) {
      return params.data.first_name + ' ' + params.data.surname;
    },
    // h_assigned_date_vg(params) {
    //   return this.$options.filters.formatDateTime(params.data.created_at);
    // },
    h_pay_rate_vg(params) {
      return this.$options.filters.currency(params.data.pay_amount);
    },
    // h_admin_rate_vg(params) {
    //   if (params.data.position_rate.admin_fee_type === '£ (pound)') {
    //     return this.$options.filters.currency(params.data.position_rate.admin_fee_amount);
    //   }
    //   else if (params.data.position_rate.admin_fee_type === '% (percentage)') {
    //     return this.$options.filters.percentage(params.data.position_rate.admin_fee_amount);
    //   }
    // },
    h_start_date_vg(params) {
      return this.$options.filters.formatDate(params.data.start_date);
    },
    h_end_date_vg(params) {
      return this.$options.filters.formatDate(params.data.end_date);
    },
    h_gang_leader_vg(params) {
      return params.data.is_gang_leader ? 'Yes' : 'No';
    },
    h_part_of_gang_vg(params) {
      return params.data.gang_leader !== null ? 'Yes' : 'No';
    },
    h_gang_lead_by_vg(params) {
      // return params.data.gang_leader !== null ? params.data.gang_leader.full_name : '';
    },
  }
}
</script>

<style scoped>

</style>
